<template>
  <Mutation
    :mutation="mutation"
    :variables="variables"
    @done="onDone"
    @error="onError"
  >
    <template v-slot="{ mutate, loading }">
      <ValidationObserver
        ref="observer"
        v-slot="{ valid, invalid }"
        tag="form"
        @submit.prevent="mutate"
      >

        <div class="sm:flex sm:items-start">
          <div class="sm:mt-0 sm:text-left w-full">
            <TextInput v-model.trim="proposedFirst" name="First" label="First" rules="required"/>
          </div>
        </div>

        <div class="sm:flex sm:items-start">
          <div class="sm:mt-0 sm:text-left w-full">
            <TextInput v-model.trim="proposedLast" name="Last" label="Last" />
          </div>
        </div>

        <div class="sm:flex sm:items-start">
          <div class="sm:mt-0 sm:text-left w-full">
            <TextInput v-model.trim="proposedSchoolIdentifier" name="School Identifier" label="School Identifier" />
          </div>
        </div>

        <div class="rounded-md shadow-sm w-full">
          <label for="proposedGradeLevel" class="block text-sm font-medium leading-5 text-gray-700">
            Grade Level
          </label>
          <select id="proposedGradeLevel" class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" v-model="proposedGradeLevel">
            <option :value="null">None selected</option>
            <option :value="gradeLevel" v-for="gradeLevel in gradeLevels" :key="gradeLevel.id">
              {{gradeLevel.name}}
            </option>
          </select>
        </div>

        <div class="mt-8">
          <div class="flex justify-end">
            <span class="ml-3 inline-flex rounded-md shadow-sm">
              <button type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:ring-indigo active:bg-indigo-700 transition duration-150 ease-in-out">
                Save
              </button>
            </span>
          </div>
        </div>


      </ValidationObserver>

    </template>
  </Mutation>
</template>

<script>
import Mutation         from '@/components/Mutation.vue'
import TextInput from '@/components/TextInput.vue'
import StudentUpdateMutation from '@/mutations/StudentUpdate.gql'
import {
  ValidationObserver,
  ValidationProvider
} from "vee-validate"
import { tz }           from '@/tz'
import _get from 'lodash-es/get'

export default {
  components: {
    Mutation,
    TextInput,
    ValidationObserver,
    ValidationProvider
  },

  props: {
    student: {
      required: true,
      type: Object
    },
    gradeLevels: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      proposedFirst: undefined,
      proposedLast: undefined,
      proposedSchoolIdentifier: undefined,
      proposedGradeLevel: undefined,
      mutation: StudentUpdateMutation
    }
  },

  computed: {
    variables() {
      return {
        id: _get(this, 'student.id'),
        first: this.proposedFirst,
        last: this.proposedLast,
        schoolIdentifier: this.proposedSchoolIdentifier,
        gradeLevelId: _get(this.proposedGradeLevel, 'id'),
        tz: tz()
      }
    }
  },

  mounted() {
    this.proposedFirst            = this.student.first
    this.proposedLast             = this.student.last
    this.proposedSchoolIdentifier = this.student.schoolIdentifier
    this.proposedGradeLevel       = this.student.gradeLevel
  },

  watch: {
    student(newStudent, oldStudent) {
    this.proposedFirst            = newStudent.first
    this.proposedLast             = newStudent.last
    this.proposedSchoolIdentifier = newStudent.schoolIdentifier
    this.proposedGradeLevel       = newStudent.gradeLevel
    }
  },

  methods: {
    onDone() {
      Bus.$emit('flash-message', {text: 'Student updated', type: 'success'})
    },

    onError(e) {
      Bus.$emit('flash-message', {text: e, type: 'error'})
    }
  },
}
</script>
